import { memo, useMemo } from 'react';
import _get from 'lodash/get';
import { IAppContextStore, useAppContext } from '../../../context/app-context';
import { filterItems } from '../../../helpers/contentful-helper';
import { ArrowRightIcon } from '../../icons';
import { Entry } from 'contentful';
import { IProgramSection } from './program-section.types';

const ProgramSection: React.FC = () => {
  const { rawContentFul }: IAppContextStore = useAppContext();
  const programSection: Entry<IProgramSection> = useMemo(() => (
    filterItems(rawContentFul, 'newHomepageProgramSection')?.[0]
  ) as Entry<IProgramSection>, [rawContentFul]);

  return (
    <section id='our-programs' className='bg-[#202020] relative w-full px-4 py-8 md:py-16'>
      <h2 className='text-22 md:text-40 md:leading-[48px] font-bold text-white
        max-w-[240px] md:max-w-4xl w-full mx-auto font-inter mb-5'>
        {_get(programSection, 'fields.title')}
      </h2>
      <p className='hidden md:block text-white text-center
        text-20 leading-7 mb-16 max-w-6xl w-full mx-auto font-sans'>
        {_get(programSection, 'fields.subtitle.content', []).map((content: any) => (
          _get(content, 'content', []).map((item: any, index: number) => (
            <span
              key={index}
              {
                ...item.nodeType === 'text' && _get(item, 'marks.[0].type', '') === 'bold'
                  ? { className: 'font-bold' }
                  : {}
              }
            >
              {item.value}
            </span>
          )))
        )}
      </p>
      <div className='grid grid-cols-1 md:grid-cols-2 max-w-6xl w-full mx-auto text-white mb-8'>
        {
          _get(programSection, 'fields.programs', []).map((program: any, index: number) => (
            <div key={index}
              className={`relative px-0 md:px-4 ${index === 0 ? 'border-b md:border-b-0 md:border-r border-[#545454] pb-8 md:pb-0' : 'pt-8 md:pt-0'
                }`}
            >
              <div
                className='relative max-w-[420px] w-full h-full
                  mx-auto flex flex-col justify-between gap-6'
              >
                <div className='relative'>
                  <h3 className='text-[#F83D11] font-bold text-18 md:text-32 mb-6 font-inter text-center'>
                    {_get(program, 'title', '')}
                  </h3>
                  <p className='font-sans text-16 leading-6 relative'>
                    {_get(program, 'description', '')}
                  </p>
                </div>
                <div className='relative text-white'>
                  <a
                    href={_get(program, 'url', '')}
                    className='relative md:inline-flex bg-[#F83D11]
                      text-white px-8 py-3 rounded-[50px] font-sans
                      font-bold text-16 leading-6 text-center
                      flex justify-center gap-2'
                  >
                    Learn More
                    <ArrowRightIcon />
                  </a>
                </div>
              </div>
            </div>
          ))
        }
      </div>
      <div className='text-white max-w-[800px] w-full mx-auto text-center'>
        <div className='text-16 font-bold mb-6 md:mb-2 max-w-[240px] md:max-w-full w-full mx-auto'>
          {_get(programSection, 'fields.titleNote')}
        </div>
        <p>
          {_get(programSection, 'fields.descriptionNote.content', []).map((descriptionNote: any) => (
            _get(descriptionNote, 'content', []).map((item: any, index: number) => (
              <span key={index}>{item.value}</span>
            ))
          ))}
        </p>
      </div>
    </section>
  )
};

export default memo(ProgramSection);
